/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as SaveSvg } from "../../../resources/images/save-icon.svg";

/* Styles */
import styles from "./styles";

const PolicyUnsavedChangesModal = ({
  showModal,
  setShowModal,
  onSave,
  onCancel,
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.unsavedChangesModal}
      customStyle={classes.unsavedChangesModalWrapper}
      showModal={showModal}
      setShowModal={setShowModal}
      modalIcon={<SaveSvg />}
      modalHeaderTitle={
        <div className={classes.modalHeaderWrapper}>
          <h3>
            <FormattedMessage id="policyUnsavedChangesModal.title" />
          </h3>
          <p>
            <FormattedMessage id="policyUnsavedChangesModal.saveDescription" />
          </p>
        </div>
      }
      modalContent={<Content onSave={onSave} onCancel={onCancel} />}
    />
  );
};

export default PolicyUnsavedChangesModal;
